import React from 'react';
import PropTypes from 'prop-types';
import { SanitizeHtml, Image, withSize } from '@bd/bdcore-utilities';
import LightBox from '@bd/bdui-lightbox';
import { chunk, get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import PageSectionHeading from '../../PageSectionHeading';

import { colors, typography } from '../../../styles';

const styles = css`
  padding:45px 0;
  @media (min-width: 991px) {
    padding:90px 0;
  }
  .PageTestimonials_list {
    @media (min-width: 992px) {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }
    li {
      display: flex;
      flex-direction: column;
      border-top: 1px solid #C9D4DC;
      padding: 50px 0 0;
      margin: 50px 0 0;
      @media (min-width: 768px) {
        border-top: 0;
        padding: 60px 50px;
        margin: 0;
        background-image: linear-gradient(53deg, rgba(227,239,247,0.00) 0%, #C2DAEB 94%);
        justify-content: center;
        &:nth-child(2) {
          background-image: linear-gradient(145deg, #5CB2C1 0%, #22517E 100%);
          .Testimonials_body p {
            color: white;
            @media (min-width: 992px) {
              font-size: 26px;
            }
          }
          .Testimonials_name {
            color: white;
          }
          .Testimonial_image {
            @media (min-width: 1200px) {
              margin: 0 30px 0 0;
            }
          }
        }
        &:nth-child(3) {
          background-image: linear-gradient(145deg, #22517E 0%, #032A4F 100%);
          .Testimonials_body p {
            color: white;
            @media (min-width: 992px) {
              font-size: 26px;
            }
          }
          .Testimonials_name {
            color: white;
          }
          .Testimonial_image {
            @media (min-width: 1200px) {
              margin: 0 0 0 30px;
            }
          }
        }
      }
      @media (min-width: 992px) {
        padding: 80px 40px;
        &:nth-child(1) {
          grid-column: 1;
          grid-row: 1 / 3;
        }
      }
      @media (min-width: 992px) {
        padding: 80px 80px;
      }
    }
  }
  .PageTestimonials_listAlt .PageTestimonials_list {
    li {
      &:nth-child(1) {
        @media (min-width: 992px) {
          grid-column: 2;
        }
      }
    }
  }
  .NoBorderTop {
    border: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
    @media (min-width: 768px) {
      padding: 60px 50px !important;
    }
    @media (min-width: 992px) {
      padding: 80px 40px !important;
    }
    @media (min-width: 1500px) {
      padding: 80px 80px !important;
    }
  }
  .Testimonial_image {
    border-radius: 50%;
    width: 191px;
    height: 191px;
    object-fit: cover;
    margin: 0 auto 15px;
    @media (min-width: 768px) {
      width: 200px;
      height: 200px;
    }
    @media (min-width: 1500px) {
      margin: 0 0 35px;
      width: 330px;
      height: 330px;
    }
  }
  .Testimonials_content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    margin: 0 15px;
    @media (min-width: 992px) {
      margin: 0;
    }
  }
  .Testimonials_body {
    margin: 0 0 10px 0;
    p {
      font-weight: 400;
      font-size: 15px;
      color: ${colors.body};
      letter-spacing: 0;
      margin: 0 0 10px;
      font-family: ${typography.Serif};
      line-height: 1.7;
      @media (min-width: 992px) {
        font-size: 23px;
      }
      @media (min-width: 1500px) {
        font-size: 32px;
      }
    }
  }
  .Testimonials_name {
    font-weight: 700;
    font-size: 15px;
    color: ${colors.body};
    letter-spacing: 0;
    line-height: 1.2;
    @media (min-width: 992px) {
      font-size: 18px;
    }
    @media (min-width: 1500px) {
      font-size: 21px;
    }
  }
  .Testimonial_imageWrapper {
    position: relative;
    width: fit-content;
    margin: 0 auto;
    @media (min-width: 992px) {
      margin: 0;
    }
  }
  .Testimonial_videoButton {
    cursor: pointer;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 15px;
    background-image: url('/images/icon-play-button-white.svg');
    background-position: center center;
    background-size: 60px 60px;
    background-repeat: no-repeat;
    display: block;
    z-index: 2;
    transition: all .3s ease;
    @media (min-width: 1500px) {
      background-size: 90px 90px;
    }
    &:hover {
      transform: scale(1.23);
    }
  }
`;

const videoCss = css`
  margin: 10vh auto 0;
  @media (min-width: 992px) {
    width: 75vw;
    margin: 10vh auto 0;
  }
`;

class PageTestimonials extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: 2,
    };
  }
  addMoreTestimonials = () => {
    this.setState({
      limit: this.state.limit + (this.props.size.width < 992 ? 6 : 2),
    });
  }
  render() {
    const { content } = this.props;
    const { limit } = this.state;
    const testimonialsList = chunk(get(content, '[0].testimonials'), 3);
    return (
      <div className={styles}>
        {
          get(content, '[0].section_heading') &&
          <PageSectionHeading h3={get(content, '[0].section_heading')} underdog />
        }
        <div className="container-fluid px-md-0">
          <ul className="list-unstyled">
            {
              testimonialsList.slice(0, limit).map((list, i) => (
                <li key={i.toString()} className={i % 2 !== 0 ? 'PageTestimonials_listAlt' : ''}>
                  <ul className="list-unstyled PageTestimonials_list">
                    {
                      list.map((test, index) => (
                        <li key={test._id} className={`${i === 0 && index === 0 ? 'NoBorderTop' : ''} ${index !== 0 ? 'flex-xl-row' : ''}`}>
                          {
                            get(test, 'photo.contentUrl') &&
                            <div className={`Testimonial_imageWrapper ${index === 2 ? 'order-xl-1' : ''} ${index === 0 ? '' : 'my-lg-auto'}`}>
                              <Image
                                src={get(test, 'photo.contentUrl')}
                                width={1200}
                                height={1200}
                                className="Testimonial_image"
                                alt={get(test, 'photo.name', get(test, 'photo.caption', ''))}
                              />
                              {
                              get(test, 'video') &&
                                <LightBox
                                  enableZoom
                                  items={[
                                    {
                                      element: (
                                        <div
                                          className={`${videoCss} embed-responsive embed-responsive-16by9`}
                                          dangerouslySetInnerHTML={SanitizeHtml(get(test, 'video'))}
                                        />
                                      ),
                                    },
                                  ]}
                                >
                                  <span className="Testimonial_videoButton" role="button" tabIndex="0" />
                                </LightBox>
                              }
                            </div>
                          }
                          <div className="Testimonials_content">
                            <div className="Testimonials_body" dangerouslySetInnerHTML={SanitizeHtml(get(test, 'message'))} />
                            <h4 className="Testimonials_name">
                              {
                                [
                                  test.name,
                                  test.location,
                                ].filter(v => v).join(' | ')
                              }
                            </h4>
                          </div>
                        </li>
                      ))
                    }
                  </ul>
                </li>
              ))
            }
          </ul>
          {
            testimonialsList.length > limit &&
            <div className="d-flex justify-content-center mt-4">
              <span onClick={this.addMoreTestimonials} role="button" tabIndex={0} className="btn btn-brand5 btn-arrow-black">Load More</span>
            </div>
          }
        </div>
      </div>
    );
  }
}

PageTestimonials.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
  size: PropTypes.object.isRequired,
};
PageTestimonials.defaultProps = {
};

export default withSize()(PageTestimonials);



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/PageTestimonials.section.js